function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M600 0s-82.117 4.923-123.681 57.72C339.992 230.876 239.994 247.367 239.994 247.367S149.997 278.206 0 278.206V470h600V0z",
  fill: "url(#lines_svg__paint0_linear_603_11541)"
});

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "lines_svg__paint0_linear_603_11541",
  x1: 150,
  y1: 117.5,
  x2: 150,
  y2: 117.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#26869A",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#26869A",
  stopOpacity: 0.502
})));

function SvgLines(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 470",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgLines;